/**
 * Gets realized for contact guid for opened reservation.
 *
 * @param {object} props
 */
export function resolveRealizedForId (props) {
  let realisedForId = props.defaultRealisedFor ? props.defaultRealisedFor.id : null

  if (props.reservation && props.reservation.formData.realisedFor) {
    realisedForId = props.reservation.formData.realisedFor
  }

  return realisedForId
}

/**
 * Gets default service for reservation.
 *
 * @param {string} fromEquipmentId
 * @param {object} equipment
 * @param {object} props
 */
export function resolveDefaultService (fromEquipmentId, equipment, props) {
  if (props.defaultFormService) {
    return props.defaultFormService
  }

  if (fromEquipmentId && undefined !== equipment[fromEquipmentId] && equipment[fromEquipmentId].ge_defaultformservice) {
    return equipment[fromEquipmentId].ge_defaultformservice.Id
  }

  return ''
}

/**
 * Prepairs materials options for select.
 *
 * @param {object} materials
 */
export function prepareMaterialsOptions (materials) {
  const options = {}

  if (typeof materials !== 'undefined') {
    Object.keys(materials).forEach((key) => {
      options[key] = materials[key].name
    })
  }

  return options
}
